import React, { useState, useEffect } from 'react';
import CustomerBooking from './CustomerBooking';
import { BusinessAPI } from '../../services/api/businessAPI';

const CustomerBookingPage = ({ businessSlug }) => {
  const [businessContext, setBusinessContext] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const resolveBusiness = async () => {
      try {
        setLoading(true);
        setError(null);
        const business = await BusinessAPI.resolveBusinessSlug(businessSlug);
        setBusinessContext(business);
      } catch (err) {
        console.error('Failed to resolve business:', err);
        setError('עסק לא נמצא או אינו פעיל');
      } finally {
        setLoading(false);
      }
    };

    if (businessSlug) {
      resolveBusiness();
    }
  }, [businessSlug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-rose-500 mx-auto mb-4"></div>
          <p className="text-gray-600">טוען...</p>
        </div>
      </div>
    );
  }

  if (error || !businessContext) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">שגיאה</h1>
          <p className="text-gray-600 mb-4">{error}</p>
          <button 
            onClick={() => window.location.href = '/'}
            className="bg-rose-500 text-white px-6 py-2 rounded-lg hover:bg-rose-600"
          >
            חזור לעמוד הראשי
          </button>
        </div>
      </div>
    );
  }

  return (
    <CustomerBooking 
      businessSlug={businessSlug}
    />
  );
};

export default CustomerBookingPage;